module.exports = __webpack_public_path__ + "static/media/backing.65718858.png";